import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Translate } from 'react-localize-redux';

import { normalizeTitle } from '@webapp/utils/normalizers';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';

import DropdownCtrl from '@webapp/controllers/form/dropdown';

import TRACK_VERSIONS from './version.json';

interface TrackVersionCtrlProps {
  id?: string;
  className?: string;
  trackId: string;
  locked?: boolean;
}

interface StoreProps {
  version: string;
  onChange: (value: string) => UpdateTrackField<'trackVersion'>;
}

const mapStateToProps = (state: AppState, props: TrackVersionCtrlProps) => ({
  version: state.tracks.tracks[props.trackId].trackVersion || '',
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  props: TrackVersionCtrlProps
) => ({
  onChange: (value: string) =>
    dispatch(new UpdateTrackField(props.trackId, 'trackVersion', value)),
});

export const TrackVersionCtrl: React.FC<TrackVersionCtrlProps & StoreProps> = (
  props
) => {
  const handleChange = (value: string) => {
    if (props.locked) {
      return;
    }
    if (value === 'Original') {
      props.onChange('');
    }
    props.onChange(normalizeTitle(value));
  };

  return (
    <DropdownCtrl
      id={props.id}
      className={props.className}
      title={<Translate id="RELEASE.TRACK_INFO.TRACK.VERSION" />}
      value={props.version || undefined}
      disabled={props.locked}
      showSelectableOption={true}
      onChange={(value: string) => handleChange(value)}
      options={TRACK_VERSIONS.list?.sort((a, b) =>
        a.value.localeCompare(b.value)
      )}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackVersionCtrl);
